import { useRef } from "react";

/**
 * Tracks data version for cache invalidation.
 * Returns a counter that increments when dependencies change.
 */
export const useDataVersion = (deps: React.DependencyList): number => {
  const versionRef = useRef(0);
  const prevDepsRef = useRef<React.DependencyList>(deps);

  const depsChanged = deps.some((dep, i) => dep !== prevDepsRef.current[i]);
  if (depsChanged) {
    versionRef.current++;
    prevDepsRef.current = deps;
  }

  return versionRef.current;
};
